import axios from 'axios'
import { Message } from 'element-ui'

// create an axios instance
const service = axios.create({
    //baseURL: '',
    //baseURL: 'http://8.217.25.32/we7',
    baseURL: 'https://w9.nowaittech.com',
    //baseURL: 'http://localhost:8080/we7',
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 30000 // request timeout
})

service.interceptors.request.use(
    config => {
        if(config.method === 'post') {
            // config.data.id =  '16'
        }
        else {
            // config.params.qyid =  '16'
        }
        // do something before request is sent
        const auser = JSON.parse(window.localStorage.getItem('auserinfo'))
        const token = auser.authorizetoken;
        console.log('aaa')
        //if(token) {
            config.headers['Authorization'] = `Bearer 6i8E18zAcerg3e553WywTf6hgTmQxk6PcwtE5fdqdMiN5Y8Tf5r6R0851P8h9V28Uuh6NkGg8aJS$`;
        //}

        return config
    },
    error => {
        error.message = '网络连接失败，请稍后重试'
        Message({
            message: error.message,
            type: 'error'
        })
        
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    response => {
        const res = response.data
        return res
    },
    error => {
        // eslint-disable-next-line
        error.message = '网络连接失败，请稍后重试'
        Message({
            message: error.message,
            type: 'error'
        })
        return Promise.reject(error)
    }
)
  
export default service